import { render, staticRenderFns } from "./upload-clientes.vue?vue&type=template&id=801f53b8"
import script from "./upload-clientes.vue?vue&type=script&lang=js"
export * from "./upload-clientes.vue?vue&type=script&lang=js"
import style0 from "./upload-clientes.vue?vue&type=style&index=0&id=801f53b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports